export default {
    methods: {
        //FILTERS
        async setFilters(data, reload = false, pagination = null) {
            try {
                this.l_preventFormSubmitOnFilterChangeByCode = this.preventFormSubmitOnFilterChangeByCode;
                if (pagination) {
                    for (let key in pagination) {
                        if (key === 'orderBy') this.setOrderBy(pagination[key]);
                        else if (key === 'pageSize') this.setPageSize(pagination[key]);
                        else if (key === 'page') this.setPage(pagination[key]);
                    }
                } else {
                    if (data.order_by) this.setOrderBy(data.order_by);
                    this.setPage(0);
                }
                this.l_filters = data;
                if (this.consoleLogs && reload) console.log("setFilters loadList");
                if (reload) await this.loadList(true);
                return true;
            } catch (err) {
                console.log(err);
                throw err;
            }
        },
        async updateFilters(mode_filters, reload = false, pagination = null, fromMode = false) {
            try {
                this.l_preventFormSubmitOnFilterChangeByCode = this.preventFormSubmitOnFilterChangeByCode;
                if (pagination) {
                    for (let key in pagination) {
                        if (key === 'orderBy') this.setOrderBy(pagination[key]);
                        else if (key === 'pageSize') this.setPageSize(pagination[key]);
                        else if (key === 'page') this.setPage(pagination[key]);
                    }
                } else {
                    this.setPage(0);
                }
                let l_filters = JSON.parse(JSON.stringify(this.l_filters));

                console.log("l_filters", l_filters);
                // set any of the filters that aren't in the mode to null if fromMode is true
                if (fromMode) {
                    //loop through the local_filters keys
                    for (let key in l_filters) {
                        if (typeof mode_filters[key] === 'undefined') {
                            //check for a default value in the data_definition and apply if found
                            let found = app.sdk[`${this.dbName}`][`${this.dbTableName}_list_inputs`].find(input => input.name === key);
                            if (found && found.default_value) {
                                l_filters[key] = found.default_value;
                            } else {
                                l_filters[key] = null;
                            }
                        }
                    }
                }

                //The set the filters to the mode values
                for (let key in mode_filters) {
                    l_filters[key] = mode_filters[key]
                }
                this.l_filters = l_filters;
                if (this.consoleLogs && reload) console.log("updateFilters loadList")
                if (reload) await this.loadList(true);
                return true;
            } catch (err) {
                console.log(err);
                throw err;
            }
        },
        getFilters() {
            return JSON.parse(JSON.stringify(this.l_filters));
        },
    }
}
